module.exports = __webpack_public_path__ + "static/media/modamilyText@3x.bf23c5c3.png";